import { useEffect, useEffectEvent } from "react"

export function useAutoDismiss(active: boolean, reset: () => void, delayMs = 5_000) {
  const onReset = useEffectEvent(reset)

  useEffect(() => {
    if (!active) return

    const timeoutId = setTimeout(onReset, delayMs)
    return () => clearTimeout(timeoutId)
  }, [active, delayMs])
}
